import React, { useState, useEffect, useCallback } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux';
import { Box, Button, Popover, Tab, Tabs, Typography , IconButton,  } from '@mui/material'
import * as actions from '../../reducers/formTable';
import * as actions2 from '../../reducers/form';
import * as actionAuto from '../../reducers/autocomplite'
import { fetchDispath } from '../../functions/fetch'
import { getEstimate, getGroup } from '../../api/estimate'
// import EstimateCreateLink from './EstimateCreateLink'
import TableGroup from './GroupTable'
import EstimateTable from './EstimateTable'
import DialogAddEditGroup from './DialogAddEditGroup'
import CreateShareLink from '../../components/CreateShareLink'
import { SLUGS } from 'src/enum/permissions.enum';
import { useCan } from 'src/hooks/useCan';
import EstimateHistory from './EstimateHistory';
import { useParams } from 'react-router-dom';
import ReplayIcon from '@mui/icons-material/Replay'
const formName = 'EstimateList'
const formGName = 'groupEstimate'
const formRName = 'groupResEstimate'
const formDialog = 'dialogEL'
const autoGroup = 'group'

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}
function TabPanel({ children, value, index }) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {children}
    </Box>
  );
}
export default function EstimateList() {
  const [anchorEl, setAnchorEl] = useState(null)
  const [tabValue, setTabValue] = useState(0);
  const { idProject } = useParams()
  const [changeGroup, setChangeGroup] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.initFormTableMulti([{ name: formName }, { name: formGName }, { name: formRName }]))
    dispatch(actions2.formInitialize({
      selectedEstimate: [],
      selectedEstimateById: {},
      selectedGroup: null,
      summEstimate: 0,
      summGroup: 0,
      selectedMainEstimate: {},
    }, { name: formName }))
    dispatch(actions2.formInitialize({
      dialogGroup: true,
      dialogGroupAdd: true,
      dialogGroupName: '',
      dialogGroupNumber: 0,
      dialogGroupId: null,
      dialogGroupIdTable: null,
    }, { name: formDialog }))
    dispatch(actionAuto.initialAutocomplite({ field: autoGroup }))
    return () => {
      dispatch(actions.clearFormTable(formName))
      dispatch(actions.clearFormTable(formGName))
      dispatch(actions.clearFormTable(formRName))
      dispatch(actions2.formDestroy({ name: formName }))
      dispatch(actions2.formDestroy({ name: formDialog }))
      dispatch(actionAuto.clearAutocomplite({ field: autoGroup }))
    }
  }, [dispatch])

  const loadEstimate = useCallback(() => {
    dispatch(fetchDispath({
      param: {
        id: idProject
      },
      progress: true,
      request: getEstimate,
    }))
      .then(res => {
        let summ = 0
        const arr = res.get.map(e => {
          summ += Math.round(100 * e.count * Number(e.price)) / 100 || 0
          return {
            ...e,
            summ: Math.round(100 * e.count * e.price) / 100,
            finder: `${e.name?.toLocaleLowerCase() || ''}${e.typeMark?.toLocaleLowerCase() || ''} ${e.vendorCode?.toLocaleLowerCase() || ''}`
          }
        })
        batch(() => {
          dispatch(actions.loadFormTable({ count: res.count, get: arr }, { name: formName, id: 'id' }))
          dispatch(actions2.formChange(summ, { field: 'summEstimate', name: formName }))
        })
      }).catch(err => console.log(err))
  }, [dispatch, idProject])
  const loadGroup = useCallback(() => {
    dispatch(fetchDispath({
      param: {
        id: idProject
      },
      progress: true,
      request: getGroup,
    })).then(res => {
      const { list, group } = res
      let gobj = {}
      let summGroup = 0;
      group.forEach((el, i) => {
        gobj[el.id] = { res: [], summ: 0 };
      });
      list.forEach((el, i) => {
        gobj[el.idGroup].res.push('id' + el.id + '_' + i);
        gobj[el.idGroup].summ += Number(el.summ) || 0
        summGroup += Number(el.summ) || 0
      });
      const groupAr = res.group.map(obj => ({ value: obj.id + '', label: obj.number + '. ' + obj.name }))
      batch(() => {
        dispatch(actions.loadFormTable({ count: list.length, get: list }, { name: formRName, id: 'id' }))
        dispatch(actions.loadFormTable({
          count: group.length, get: group.map(e => {
            return { ...e, res: gobj[e.id].res, ressumm: gobj[e.id].summ }
          })
        }, { name: formGName, id: 'id' }))
        dispatch(actionAuto.load(groupAr, { field: autoGroup }))
        dispatch(actions2.formChange(summGroup, { field: 'summGroup', name: formName }))
      })
    }).catch(err => console.log(err))
  }, [dispatch, idProject])
  useEffect(() => {
    loadGroup()
    loadEstimate()
  }, [dispatch, loadGroup, loadEstimate])
  const can = useCan()
  const updEstimate = can(SLUGS.PROJECT.ESTIMATE.UPDATE);

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
  };
  return <div className='App-paper'>
    <DialogAddEditGroup idProject={idProject} changeGroup={changeGroup} onClose={() => setChangeGroup(false)} />
    <SummPrice formName={formName} />
    <Tabs
      value={tabValue}
      onChange={handleTabChange}
      aria-label="Разделы сметы"
      variant="scrollable"
      scrollButtons="auto"
    >
      <Tab
        label="Смета"
        {...a11yProps(0)}
      />
      <Tab
        label="Не распределены"
        disabled={!updEstimate}
        {...a11yProps(1)}
      />
      <Tab
        label="История"
        {...a11yProps(2)}
      />
    </Tabs>
    <TabPanel value={tabValue} index={0}>
      <IconButton size="small" color='primary' onClick={() => loadGroup()}>
        <ReplayIcon />
      </IconButton>
      {updEstimate && <Button color="primary" onClick={() => setChangeGroup(true)}>Изменить группу</Button>}
      <Button onClick={e => setAnchorEl(e.currentTarget)} color="primary">Доступ по ссылке</Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={() => setAnchorEl(null)}
      >
        <CreateShareLink idProject={idProject} type={'estimate'} />
      </Popover>
      <TableGroup
        idProject={idProject}
        loadEstimate={loadEstimate}
        loadGroup={loadGroup}
        formName={formName}
      />
    </TabPanel>
    <TabPanel value={tabValue} index={1}>
      <EstimateTable
        idProject={idProject}
        reloadWhenAddToGroup={loadGroup}
        loadEstimate={loadEstimate}
        formName={formName}
      />
    </TabPanel>
    <TabPanel value={tabValue} index={2}>
      <EstimateHistory
        idProject={idProject}
        loadEstimate={loadEstimate}
        loadGroup={loadGroup}
      />
    </TabPanel>
  </div>
}


function SummPrice({ formName }) {
  const summEstimate = useSelector(state => state.form[formName]?.values.summEstimate)
  const summGroup = useSelector(state => state.form[formName]?.values.summGroup)
  const tableGroup = useSelector(state => state.formTable[formGName] || state.formTable.default)
  const tableResource = useSelector(state => state.formTable[formRName] || state.formTable.default)
  const allIdsEst = useSelector(state => state.formTable[formName]?.allIds || [])
  const byIdEst = useSelector(state => state.formTable[formName]?.byId || {})
  let summMaterial = 0
  let summWork = 0
  function calc() {
    tableGroup.allIds.forEach(key => {
      const group = tableGroup.byId[key]
      group.res.forEach(e => {
        const obj = tableResource.byId[e]
        if (obj.type === 'material') {
          summMaterial += Number(obj.summ) || 0
        }
        else {
          summWork += Number(obj.summ) || 0
        }
      })
    })
    allIdsEst.forEach(key => {
      const obj = byIdEst[key]
      if (obj.type === 'material') {
        summMaterial += Number(obj.summ) || 0
      }
      else {
        summWork += Number(obj.summ) || 0
      }
    })
  }
  calc()
  return <>
    <Typography variant='h5'>{'Всего по смете: ' + validatePrice(summEstimate + summGroup)}</Typography>
    <Typography variant='body1'>{'Всего материалов: ' + validatePrice(summMaterial)}</Typography>
    <Typography variant='body1'>{'Всего работ: ' + validatePrice(summWork)}</Typography>
    <Typography variant='body1'>Не распределено: {validatePrice(summEstimate)}</Typography>
  </>
}

function validatePrice(price) {
  return (Math.round(100 * price) / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}